var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectrolytes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2648 8.82313C23.7501 8.82313 23.3089 8.82313 22.7942 8.82313C22.7942 8.30842 22.7942 7.86725 22.7942 7.35254C22.2795 7.35254 21.8383 7.35254 21.3236 7.35254V8.82313C20.8089 8.82313 20.3677 8.82313 19.853 8.82313V10.2937H21.3236V11.7643H22.7942C22.7942 11.2496 22.7942 10.8084 22.7942 10.2937H24.2648C24.2648 9.77901 24.2648 9.33783 24.2648 8.82313Z",
    fill: "#00366D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3825 10.2943C17.8482 10.2943 14.5099 10.2943 13.9707 10.2943C13.9707 9.77961 13.9707 9.33844 13.9707 8.82373H18.3825V10.2943Z",
    fill: "#004C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94092 3.67672V8.82378L5.1468 9.31398L7.35268 8.82378L7.84287 6.98555L7.35268 3.67672L5.3919 3.18652L2.94092 3.67672Z",
    fill: "#FF8066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35303 3.67672V8.82378L9.55891 9.31398L11.7648 8.82378C11.7648 8.30908 11.7648 4.17182 11.7648 3.67672L9.31381 3.18652L7.35303 3.67672Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94092 8.82373V17.6473L5.3919 18.1375L7.35268 17.6473L7.84287 13.2355L7.35268 8.82373H2.94092Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35303 8.82373V17.6473L9.55891 18.1375L11.7648 17.6473C11.7648 17.1816 11.7648 9.10314 11.7648 8.82373H7.35303Z",
    fill: "#ECE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.735352 0V3.67647H3.67653L4.41182 3.18627L5.14712 3.67647H6.61771L7.1079 1.10294L6.61771 0H5.14712L4.41182 0.490196L3.67653 0H0.735352Z",
    fill: "#FFE278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14686 3.67647C4.63215 3.67647 4.19098 3.67647 3.67627 3.67647C3.67627 2.62255 3.67627 1.23039 3.67627 0H5.14686V3.67647Z",
    fill: "#FFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61768 0V3.67647H7.35297L7.84317 1.10294L7.35297 0H6.98532H6.61768Z",
    fill: "#FFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14697 11.0293V12.4999H7.35285L7.84305 11.7646L7.35285 11.0293C6.61756 11.0293 5.88227 11.0293 5.14697 11.0293Z",
    fill: "#7ED8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55891 11.0293C8.82362 11.0293 8.08832 11.0293 7.35303 11.0293V12.4999H9.55891V11.7646V11.0293Z",
    fill: "#6AA9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14697 13.9707V15.4413H7.35285L7.84305 14.706L7.35285 13.9707C6.61756 13.9707 5.88227 13.9707 5.14697 13.9707Z",
    fill: "#7ED8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9707 0H11.0295L10.2942 0.490196L9.55893 0H8.08834L7.59814 1.10294L8.08834 3.67647H9.55893L10.2942 3.18627L11.0295 3.67647H13.9707C13.9707 2.62255 13.9707 1.23039 13.9707 0Z",
    fill: "#FFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0297 3.67647C10.515 3.67647 10.0738 3.67647 9.55908 3.67647C9.55908 2.62255 9.55908 1.23039 9.55908 0H11.0297V3.67647Z",
    fill: "#FF936B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08832 0C7.83342 0 7.60793 0 7.35303 0V3.67647H8.08832V1.10294V0Z",
    fill: "#FF936B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94092 17.6475V20.5886C2.94092 23.0249 4.91641 25.0004 7.35268 25.0004L7.84287 20.868L7.35268 17.6475H2.94092Z",
    fill: "#FF8066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35303 17.6475V25.0004C9.7893 25.0004 11.7648 23.0249 11.7648 20.5886C11.7648 20.2308 11.7648 18.0053 11.7648 17.6475H7.35303Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4409 21.3233C15.4409 23.3527 17.088 24.9997 19.1174 24.9997L19.6076 21.0292L19.1174 15.4409C19.1125 15.4458 15.4409 19.2939 15.4409 21.3233Z",
    fill: "#FF8066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1177 15.4409V24.9997C21.1471 24.9997 22.7941 23.3527 22.7941 21.3233C22.7941 19.3037 19.1226 15.4458 19.1177 15.4409Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55891 13.9707C8.82362 13.9707 8.08832 13.9707 7.35303 13.9707V15.4413H9.55891V14.706V13.9707Z",
    fill: "#6AA9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrolytes);
export default __webpack_public_path__ + "static/media/electrolytes.fd50aa49d60b9c67bb360e8cbc66ad62.svg";
export { ForwardRef as ReactComponent };